import styled from 'styled-components'

export const GamingBgContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: none;
`
